import { css } from 'styled-components';

export const divBase = css`
	width: 100%;
`;
